var home_banner_slider = document.querySelector(".home-banner__slider")
var slider_options = {
	slidesPerView: 1,
	speed: 400,
	spaceBetween: 0,
	pagination: {
		el: ".swiper-pagination",
	},
	mousewheel: {
		forceToAxis: true,
	},
}

if (home_banner_slider.hasAttribute("data-autoplay")) {
	var delay = parseInt(home_banner_slider.dataset.autoplay)
	slider_options["autoplay"] = {
		delay,
		disableOnInteraction: false,
	}
}

const banner_slider = new Swiper(home_banner_slider, slider_options)
